import { useEffect, useRef } from "react";

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(30px)";
    const t = setTimeout(() => {
      el.style.transition = "opacity 0.9s ease, transform 0.9s ease";
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/c3309fd05322870c05ad46e1f9defe00.jpg"
          alt="XEDRA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/55 to-black/65" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 pt-24 pb-16">
        {/* Left: text */}
        <div className="flex-1 w-full text-center lg:text-left">
          <p className="inline-block text-xs uppercase tracking-widest text-white/60 mb-5 font-medium border border-white/20 rounded-full px-4 py-1.5">
            iOS Application Development
          </p>
          <h1
            ref={titleRef}
            className="text-4xl md:text-5xl lg:text-6xl font-extralight leading-tight text-white mb-6"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Modern iOS Apps
            <br />
            <span className="font-semibold">Built for Security</span>
            <br />
            &amp; Performance
          </h1>
          <p className="text-lg md:text-xl text-white/65 leading-relaxed max-w-lg mx-auto lg:mx-0">
            XEDRA d.o.o. is a team of experts crafting powerful mobile experiences — from advanced VPN protection to intelligent device optimization.
          </p>


        </div>

        {/* Right: phone mockup image */}
        <div className="flex-shrink-0 w-full max-w-xs md:max-w-sm lg:max-w-md flex justify-center">
          <div className="relative w-64 md:w-72 lg:w-80 h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=premium%20sleek%20iPhone%20smartphone%20device%20mockup%20floating%20slightly%20tilted%20showing%20a%20dark%20security%20shield%20app%20interface%20glowing%20screen%20transparent%20background%20ultra%20clean%20minimalist%20product%20shot%20soft%20ambient%20light%20from%20behind%20premium%20tech%20product%20photography%20no%20background&width=400&height=700&seq=xedra-hero-phone&orientation=portrait"
              alt="XEDRA iOS app preview"
              className="w-full h-auto object-contain drop-shadow-2xl"
            />
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10 animate-bounce">
        <span className="text-xs text-white/40 uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg" />
      </div>
    </section>
  );
}
